import React from 'react';
import { Typography } from '@mui/material';
import { func } from 'prop-types';
import { MDialog } from 'common';

const InterAffiliateDialog = ({ submit, onClose }) => {
  const dialogDetails = {
    header: 'Inter-Affiliate Order',
    leftButtonAction: onClose,
    leftButtonText: 'Back',
    onClose,
    open: true,
    rightButtonAction: submit,
    rightButtonText: 'Confirm',
  };
  const message =
    'Product Transfer Orders between your own Affiliates are automatically accepted. Please confirm you would like to continue.';

  return (
    <MDialog {...dialogDetails}>
      <Typography variant="body2">{message}</Typography>
    </MDialog>
  );
};

InterAffiliateDialog.propTypes = {
  onClose: func.isRequired,
  submit: func.isRequired,
};

InterAffiliateDialog.defaultProps = {};

export default InterAffiliateDialog;
